export var Variant = {
  Default: 'default',
  WithIcon: 'with-icon'
};